<template>
    <ModalTemplate
        :visable="visable"
        :modalStyle="{ width: width }"
        :modalClass="[{ 'modal-mobile-width': true }, 'flex flex-col']"
        @close="close"
        @minimise="minimise"
    >
        <div
            class="w-full flex items-center text-17 font-hero h-13 text-white shrink-0 grow-0"
            :class="[header ? 'bg-black stroke-white px-6 justify-between' : 'bg-white stroke-black px-4 justify-end']"
        >
            <p v-text="typeof title == 'function' ? title(data) : title" v-if="header" />

            <div class="flex items-center gap-2">
                <slot name="header-buttons-left" :data="data" />

                <button @click="close" type="button" id="modal-close" class="w-7 h-7 flex items-center justify-center">
                    <IconClose class="w-4.5 h-4.5 hover:opacity-80" />
                </button>
            </div>
        </div>

        <!-- :style='[
				buttonsFixedBottom ? "max-height: calc(100% - 52px)" : ""
			]' -->

        <Form
            :class="[
                'mt-[-1px]',
                buttonsFixedBottom ? 'grow-1 w-full flex flex-col justify-between lg:block  h-full lg:h-auto bg-white' : 'overflow-visible',
            ]"
            v-if="visable"
            :action="typeof action == 'function' ? action(data) : action"
            ref="form"
            @onSubmitted="submitted"
            v-slot="{ errors }"
        >
            <div class="p-6 relative bg-white" :class="[defaultClass, buttonsFixedBottom ? defaultOverflows : '']">
                <slot :data="data" :errors="errors" />
            </div>

            <div class="grid w-full h-fit shrink-0 px-6 pb-7" :class="buttonsClass" v-if="buttons">
                <button
                    @click="action == null ? submitted() : null"
                    v-html="typeof buttonYes == 'function' ? buttonYes(data) : buttonYes"
                    :type="action == null ? 'button' : 'submit'"
                    :class="[buttonYesClass, { 'col-span-2': !header && !buttonNoEnabled }]"
                    class="hover:black-on-white bg-black text-white h-12 w-full text-14 font-bold"
                    :name="buttonYesNameValue != null ? buttonYesNameValue[0] : null"
                    :value="buttonYesNameValue != null ? buttonYesNameValue[1] : null"
                    :disabled="$refs?.form?.saving || buttonYesDisabled"
                />

                <button
                    @click="close"
                    v-html="buttonNo"
                    type="button"
                    v-if="buttonNoEnabled"
                    :disabled="$refs?.form?.saving"
                    class="h-12 border border-black text-black w-full text-14 font-bold"
                />

                <slot name="buttons-right" />
            </div>
        </Form>
    </ModalTemplate>
</template>

<script>
export default {
    props: {
        yes: {
            type: Function,
            default: () => {},
        },
        no: {
            type: Function,
            default: () => {},
        },

        title: { type: [String, Function], default: '' },
        buttonNo: { type: String, default: 'Cancel' },
        buttonNoEnabled: { type: Boolean, default: false },
        buttonYes: { type: [Function, String], default: 'Yes' },
        buttonYesDisabled: { type: Boolean, default: false },
        buttonsClass: { type: String, default: 'grid-cols-1 lg:grid-cols-2 gap-3' },
        buttonYesClass: { type: [String, Array, Object], default: '' },
        buttonYesNameValue: { type: Array, default: null },

        width: { type: String, default: '336px' },
        defaultClass: { type: String },
        defaultOverflows: { type: String, default: 'overflow-y-auto overflow-x-hidden' },
        header: { type: Boolean, default: true },
        buttons: { type: Boolean, default: true },
        buttonsFixedBottom: { type: Boolean, default: false },

        action: { type: [String, Function], default: null },
    },

    data() {
        return {
            visable: false,
            minimised: false,
            data: null,
        }
    },

    created() {
        // this.$event.$on('modal-open', () => {
        // 	if (this.visable) {
        // 		this.close()
        // 	}
        // })
    },

    methods: {
        show(data = null) {
            this.open(data)
        },

        open(data = null) {
            // was {...data}
            // this.$event.$emit('modal-open');

            this.data = data
            this.visable = true
        },

        close() {
            // this.$refs.form.clear()
            this.visable = false
            this.no()
        },

        minimise() {
            this.minimised = true
        },

        submitted(res) {
            Promise.resolve(this.yes(res)).then(() => {
                this.visable = false
            })
        },
    },
}
</script>
